import { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import { KeyboardEvents } from 'react-native-keyboard-controller';

/**
 * Whether the on-screen keyboard is up. Both platforms report it as it starts
 * to move, so padding that depends on it changes with the keyboard rather than
 * after it. React Native's own events only offer the late `did` pair on
 * Android, which left the home-indicator gap in place until the keyboard had
 * finished opening. Always false on web, which has no on-screen keyboard
 * events to follow.
 */
export function useIsKeyboardVisible(): boolean {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (Platform.OS === 'web') {
      return;
    }

    const showSub = KeyboardEvents.addListener('keyboardWillShow', () => setIsVisible(true));

    const hideSub = KeyboardEvents.addListener('keyboardWillHide', () => setIsVisible(false));

    return () => {
      showSub.remove();

      hideSub.remove();
    };
  }, []);

  return isVisible;
}
